var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportHeartDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9205 3.14929C13.5784 2.78493 13.1722 2.4959 12.7252 2.2987C12.2782 2.1015 11.799 2 11.3151 2C10.8312 2 10.3521 2.1015 9.90504 2.2987C9.45801 2.4959 9.05185 2.78493 8.70976 3.14929L7.99982 3.90512L7.28988 3.14929C6.5989 2.41366 5.66172 2.00038 4.68453 2.00038C3.70733 2.00038 2.77016 2.41366 2.07917 3.14929C1.38819 3.88493 1 4.88267 1 5.92302C1 6.96336 1.38819 7.9611 2.07917 8.69674L2.78911 9.45256L7.99982 15L13.2105 9.45256L13.9205 8.69674C14.2627 8.33255 14.5342 7.90014 14.7194 7.42422C14.9047 6.94829 15 6.43818 15 5.92302C15 5.40785 14.9047 4.89774 14.7194 4.42182C14.5342 3.94589 14.2627 3.51348 13.9205 3.14929V3.14929Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportHeartDark);
export default __webpack_public_path__ + "static/media/support-heart-dark.188f02d55743c7104567decebab987ab.svg";
export { ForwardRef as ReactComponent };